import React, { useState } from 'react';
import styles from './AccountDeletion.module.css';

const SUPPORT_EMAIL = 'info@breathe-ev.com';
const EMAIL_SUBJECT = 'Account Deletion Request';

const AccountDeletion = () => {
    const [copied, setCopied] = useState(false);
    const mailtoLink = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(EMAIL_SUBJECT)}`;

    const handleCopyEmail = async () => {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(SUPPORT_EMAIL);
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = SUPPORT_EMAIL;
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch (error) {
            console.error('Error copying email address:', error);
        }
    };

    return (
        <div className={styles.page}>
            <div className={styles.hero}>
                <h1 className={styles.title}>Delete Your BreatheEV Account</h1>
                <p className={styles.subtitle}>
                    We're sorry to see you go. Follow the steps below to request deletion of your BreatheEV account.
                </p>
            </div>
            <div className={styles.content}>
                <div className={styles.card}>
                    <h2>How to Request Deletion</h2>
                    <p>
                        To request deletion of your BreatheEV account, send an email to{' '}
                        <span className={styles.highlight}>{SUPPORT_EMAIL}</span> with the subject line{' '}
                        <span className={styles.highlight}>"{EMAIL_SUBJECT}"</span>. Please send the request from
                        the email address associated with your account so we can verify your identity.
                    </p>
                    <div className={styles.emailButtonWrap}>
                        <a className={styles.emailButton} href={mailtoLink} rel="noopener noreferrer">
                            Email Us to Delete My Account
                        </a>
                        <button type="button" className={styles.copyButton} onClick={handleCopyEmail}>
                            {copied ? 'Copied!' : 'Copy Email Address'}
                        </button>
                        <span className={styles.emailAddress}>
                            {SUPPORT_EMAIL} &mdash; if the button above doesn't open your mail app, copy the address and email us directly.
                        </span>
                    </div>
                </div>

                <div className={styles.card}>
                    <h2>What Data Will Be Deleted</h2>
                    <p>Once your request is processed, the following data will be permanently deleted:</p>
                    <ul>
                        <li>Account profile (name, email, phone number)</li>
                        <li>Saved locations</li>
                        <li>Saved payment methods</li>
                    </ul>
                </div>

                <div className={styles.card}>
                    <h2>Data We Retain</h2>
                    <p>
                        Transaction and billing records are retained for up to <span className={styles.highlight}>7 years</span> as
                        required for legal and accounting compliance, even after your account has been deleted. This data is
                        retained solely to meet our regulatory obligations and is not used for any other purpose.
                    </p>
                </div>

                <div className={styles.card}>
                    <h2>Processing Time</h2>
                    <p>
                        Account deletion requests are processed within <span className={styles.highlight}>30 days</span> of
                        receiving your request. You will receive a confirmation email once your account and associated data
                        have been deleted.
                    </p>
                </div>

                <p className={styles.note}>
                    Questions about your data? Contact us at {SUPPORT_EMAIL}.
                </p>
            </div>
        </div>
    );
};

export default AccountDeletion;
